//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PageMixin from '@/mixins/page'

export default {
  mixins: [
    PageMixin
  ],
  layout: 'providers',
  data () {
    return {
      showCalendly: false
    }
  },
  head () {
    return {
      ...this.createSeoTags({
        title: this.$t('practitioners.seo.title'),
        description: this.$t('practitioners.seo.description'),
        url: 'https://get-base.com/providers/home',
        link: [
          {
            rel: 'preload',
            as: 'image',
            href: 'https://statics.get-base.com/affiliate/fixmydiet_header.webp'
          }
        ],
        script: [
          { src: 'https://assets.calendly.com/assets/external/widget.js', async: true }
        ],
        __dangerouslyDisableSanitizers: ['script']
      })
    }
  }
}
